import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { FunnelStageResponse } from '@/types/tags';

const colorMap: Record<string, string> = {
  gray: '#9ca3af',
  blue: '#3b82f6',
  teal: '#14b8a6',
  green: '#22c55e',
  emerald: '#10b981',
  amber: '#f59e0b',
  orange: '#f97316',
  violet: '#8b5cf6',
  red: '#ef4444',
  pink: '#ec4899',
};

interface FunnelChartProps {
  stages: FunnelStageResponse[];
  height?: number;
}

export function FunnelChart({ stages, height = 260 }: FunnelChartProps) {
  const sorted = [...stages].sort((a, b) => a.order - b.order);
  const data = sorted.map((s) => ({
    name: s.name,
    users: s.user_count,
    color: colorMap[s.color] ?? colorMap.gray,
    slug: s.slug,
  }));

  if (data.length === 0) {
    return <p className="text-sm text-muted-foreground">No funnel data.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} layout="vertical" margin={{ left: 16, right: 16 }}>
        <XAxis type="number" hide />
        <YAxis
          dataKey="name"
          type="category"
          width={100}
          tick={{ fontSize: 12 }}
          stroke="currentColor"
        />
        <Tooltip
          contentStyle={{
            background: 'hsl(var(--popover))',
            border: '1px solid hsl(var(--border))',
            borderRadius: 8,
            fontSize: 12,
          }}
          formatter={(value) => [`${Number(value ?? 0)} users`, 'Stage']}
        />
        <Bar dataKey="users" radius={[4, 4, 4, 4]}>
          {data.map((entry) => (
            <Cell key={entry.slug} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
